// Copyright © 2006-2020 Lexbe Inc. All rights reserved.

export class DocCoding {
	responsive: number;
	privilege: boolean;
	workProduct: boolean;
	redactForPrivilege: boolean;
	confidential: boolean;
	customDesignation: boolean;
	isKey: boolean;
	description: string;
	isPropagated: boolean;
	hasBeenReviewed: boolean;
	redactForPi: boolean;

	static responsiveToString(responsive: number): string {
		let responsiveString = "";

		switch (responsive) {
			case 0:
				responsiveString = ""; // Use blank as the substitute for "Not Specified"
				break;

			case 1:
				responsiveString = "Responsive";
				break;

			case 2:
				responsiveString = "Non-Responsive";
				break;

			case 3:
				responsiveString = "Needs Further Review";
				break;
		}

		return responsiveString;
	}
}
